export default function dateFilter(value, format) {
	if (value) {

		let momentString = '';

		switch(format){
		case 'short':
			momentString = 'l';
			break;
		case 'medium':
			momentString = 'll';
			break;
		case 'long':
			momentString = 'LL';
			break;
		default:
			momentString = 'll';
		}

		return moment(value).format(momentString);
	}
}



// WEBPACK FOOTER //
// ./src/filters/date.js